module.exports = __webpack_public_path__ + "img/reds.1fc5d86b.svg";